<template>
    <div class="entity-managemnet-wrap">
        <!-- 左侧结构封装 数据结构改成tree型 -->
        <EntityTrees :treeData="treesData" @change="getClassifyData" @changeClassId="classifyClick" />
        <div class="table-panel">
            <SimpleTablePage
                :pageTitle="currentClassifyName"
                :columns="columns"
                :pageLength="listInfo.size"
                :pageLengthRank="pageLengthRank"
                :total="listInfo.total"
                :dataset="listInfo.list"
                :filters="searchFilter"
                :operationBtns="operationBtns"
                :footerOperationBtns="tableBottomBtns"
                :isHideFooter="false"
                @filterChange="filterFieldsChange"
                @pageChange="pageChange"
                @columnClick="columnClick"
                @bottomClick="bottomClick"
                @selectionChange="selectionChange"
            >
                <div slot="top">
                    <div class="page-top-tips">{{ $t("zhiji.EntityManagement.funcDescription") }}</div>
                </div>
                <span slot="operation">
                    <el-button class="import-btn" @click="importHandle" round>导入</el-button>
                    <el-button class="exprot-btn" @click="exportHandle" round>导出</el-button>
                    <OperationNoteModel>
                        <span class="span-border"><i class="info-icon"></i></span>
                    </OperationNoteModel>
                </span>
                <span class="sp-describe" slot="describe">
                    (共<span>{{ listInfo.total }}</span> 个实体组，已上线<span>{{ listInfo.onLineCount }}</span
                    >个，未上线<span>{{ listInfo.notOnLineCount }}</span
                    >个)
                </span>
            </SimpleTablePage>
        </div>
    </div>
</template>

<script>
import SimpleTablePage from "@/views/zhiji/templates/simpleTablePage/index.vue";
import { columns, bottomButtons, searchFilter } from "./config";
import { queryEntityClasses, queryEntitylist, exportEntityApi, updateEntityStatus, deleteEntity, updateEntityWeight, transferEntity } from "./server";
import EntityModal from "./components/EntityModal.vue";
import ImportEntity from "./components/ImportEntity.vue";
import OperationNoteModel from "./components/OperationNoteModel.vue";
import EntityTrees from "./components/EntityTrees.vue";

export default {
    name: "EntityManagement",
    components: {
        SimpleTablePage,
        OperationNoteModel,
        EntityTrees
    },
    data() {
        return {
            columns,
            bottomButtons,
            searchFilter,
            pageLengthRank: [10, 20, 30, 100],
            searchName: "",
            entityTotal: 0,
            listInfo: {
                page: 1,
                size: 10,
                total: 0,
                list: [],
                onLineCount: 0, //已上线
                notOnLineCount: 0 //未上线
            },
            isCheckAll: false,
            checkArr: [],
            operationBtns: [
                {
                    text: "添加实体组",
                    type: "primary",
                    round: true,
                    onClick: this.addEntity
                }
            ],
            classifyTotal: 0,
            classifyData: [],
            treesData: {},
            currentClassifyId: "",
            currentClassifyName: "全部分类",
            filterFields: {
                status: "",
                keyWordSearch: {}
            }
        };
    },
    computed: {
        gameId() {
            return this.$store.state.zhiji.gameState.gameId;
        },
        tableBottomBtns() {
            return this.getTableBottomBtns();
        },
    },
    created() {
        this.getClassifyData();
        this.getEntityList();
    },
    methods: {
        getTableBottomBtns() {
            const newTableData = this.bottomButtons;
            newTableData.some(button => {
                if (button.id === "transfer") {
                    button.getOptions = () => this.treesData.children;
                    return true;
                }
            });
            return newTableData;
        },
        async getClassifyData() {
            // 获取实体分类列表
            const { treesData } = await queryEntityClasses({ gameId: this.gameId, classifyName: this.searchName });
            this.treesData = treesData;
        },
        async getEntityList() {
            const { page, size } = this.listInfo;
            // 获取实体组列表
            const { count, list, onlineCount, offlineCount } = await queryEntitylist({
                page,
                size,
                gameId: this.gameId,
                classifyId: this.currentClassifyId,
                ...this.filterFields
            });
            this.listInfo.list = list;
            this.listInfo.total = count;
            this.listInfo.onLineCount = onlineCount;
            this.listInfo.notOnLineCount = offlineCount;
            this.checkArr = [];
            this.isCheckAll = false;
        },
        classifyClick(data) {
            this.currentClassifyId = data.id;
            this.currentClassifyName = data.label;
            this.getEntityList();
        },
        addEntity() {
            this.$store.commit("zhiji/showModal", {
                type: EntityModal,
                data: {
                    title: "新增实体组",
                    type: "add",
                    classifyOptions: treeToSelector(this.treesData.children),
                    entityData: {
                        classify_id: this.treesData.children.find(item => item.id === this.currentClassifyId) ? "" : this.currentClassifyId
                    },
                    confirm: state => {
                        this.$message({
                            message: state ? "新实体组已成功上线" : "新实体组已保存",
                            type: "success"
                        });
                        this.getEntityList();
                    }
                }
            });
        },
        filterFieldsChange({ filterFields }) {
            this.filterFields = filterFields;
            this.getEntityList();
        },
        pageChange(data) {
            const { curPage, pageLength } = data;
            this.listInfo.page = curPage;
            this.listInfo.size = pageLength;
            this.getEntityList();
        },
        async columnClick(data) {
            const { rowData, originEvent } = data;
            if (originEvent.type === "Link") {
                // 编辑实体
                this.$store.commit("zhiji/showModal", {
                    type: EntityModal,
                    data: {
                        title: "编辑实体组",
                        type: "edit",

                        classifyOptions: treeToSelector(this.treesData.children),
                        entityData: rowData,
                        confirm: state => {
                            this.$message({
                                message: state ? "实体组已成功上线" : "实体组已保存",
                                type: "success"
                            });
                            this.getEntityList();
                        }
                    }
                });
            }
            if (originEvent.value === "off") {
                // 下线
                this.changeEnityStatus(0, rowData.entity_group_id);
            }
            if (originEvent.value === "on") {
                // 上线
                this.changeEnityStatus(1, rowData.entity_group_id);
            }
            if (originEvent.value === "del") {
                // 删除
                this.$confirm("确定删除该实体组吗？", this.$t("zhiji.common.tips"), {
                    confirmButtonText: this.$t("zhiji.common.confirm"),
                    cancelButtonText: this.$t("zhiji.common.cancel"),
                    type: "warning"
                }).then(() => {
                    this.deleteEntity(rowData.entity_group_id);
                });
            }

            if (originEvent.value === "updateWeight") {
                // 优先级项可编辑
                this.listInfo.list.forEach(item => {
                    if (item.entity_group_id === rowData.entity_group_id) {
                        item.editable = true;
                    }
                })
            }
            if (originEvent.value === "changeWeight") {
                const { newV, oldV } = originEvent;
                if (newV && newV != oldV) {
                    // 调请求
                    await updateEntityWeight({
                        gameId: this.gameId,
                        entityGroupId: rowData.entity_group_id,
                        weight: newV
                    })
                    this.getEntityList();
                } else{
                    // 关闭可编辑
                    this.listInfo.list.forEach(item => {
                        if (item.entity_group_id === rowData.entity_group_id) {
                            item.editable = false;
                        }
                    })
                }
            }
        },
        bottomClick({ data, originEvent }) {
            // 表格底部批量操作按钮触发事件
            if (this.checkArr.length === 0) {
                this.$confirm("请选择一条实体组!", "提示", {
                    distinguishCancelAndClose: true,
                    type: "warning",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消"
                });
                return;
            }
            const ids = this.checkArr.join(",");
            if (data.id === "del") {
                // 批量删除
                this.$confirm(`确定删除${this.checkArr.length}个实体组吗？`, this.$t("zhiji.common.tips"), {
                    confirmButtonText: this.$t("zhiji.common.confirm"),
                    cancelButtonText: this.$t("zhiji.common.cancel"),
                    type: "warning"
                }).then(() => {
                    this.deleteEntity(ids);
                });
            } else if (data.id === "online") {
                // 批量上线
                this.$confirm(`确定上线${this.checkArr.length}个实体组吗？`, this.$t("zhiji.common.tips"), {
                    confirmButtonText: this.$t("zhiji.common.confirm"),
                    cancelButtonText: this.$t("zhiji.common.cancel"),
                    type: "warning"
                }).then(() => {
                    this.changeEnityStatus(1, ids);
                });
            } else if (data.id === "offline") {
                // 批量下线
                this.$confirm(`确定下线${this.checkArr.length}个实体组吗？`, this.$t("zhiji.common.tips"), {
                    confirmButtonText: this.$t("zhiji.common.confirm"),
                    cancelButtonText: this.$t("zhiji.common.cancel"),
                    type: "warning"
                }).then(() => {
                    this.changeEnityStatus(0, ids);
                });
            } else if (data.id === "transfer" && originEvent.option.level > 1) {
                this.enityTransfer(ids,originEvent.option.id).then(()=>{
                    this.showSuccessTip(this.$t("zhiji.knowlege.transferSuc"));
                })
            } else if (data.id === "transfer" && originEvent.option.level === 1) {
                this.showSuccessTip(this.$t("zhiji.knowlege.transferRule"), 'warning');
            }
        },
        selectionChange(data) {
            // 存选中id
            this.checkArr = data.map(item => item.entity_group_id);
        },
        importHandle() {
            // 导入实体组
            this.$store.dispatch("zhiji/showModal", {
                type: ImportEntity,
                data: {
                    gameId: this.gameId,
                    cancel: () => {
                        //
                    }
                }
            });
        },
        exportHandle() {
            let messageTxt = "是否导出全部数据？";
            if (this.currentClassifyId || this.filterFields.status || this.filterFields.keyWordSearch.keyWord) {
                messageTxt = "是否导出当前筛选数据？";
            }
            // 导出
            this.$confirm(messageTxt, this.$t("zhiji.common.tips"), {
                confirmButtonText: this.$t("zhiji.common.confirm"),
                cancelButtonText: this.$t("zhiji.common.cancel"),
                type: "warning"
            }).then(() => {
                // 调接口导出
                const { page, size } = this.listInfo;
                exportEntityApi({
                    page,
                    size,
                    classifyId: this.currentClassifyId,
                    gameId: this.gameId,
                    ...this.filterFields
                });
            });
        },
        async changeEnityStatus(status, ids) {
            // 修改实体组状态
            await updateEntityStatus({
                gameId: this.gameId,
                entityGroupId: ids,
                status
            });
            this.getEntityList();
        },
        async deleteEntity(ids) {
            // 删除实体组
            this.listInfo.list;
            await deleteEntity({
                gameId: this.gameId,
                entityGroupId: ids
            });
            this.getEntityList();
        },
        async enityTransfer(ids,classifyId) {
            // 转移实体
            await transferEntity({
                gameId: this.gameId,
                entityGroupId: ids,
                classifyId,
            });
            this.getEntityList();
        },
        showSuccessTip(message, type) {
            this.$message({
                message: message,
                center: true,
                duration: 2000,
                type: type || "success"
            });
        }
    }
};

function treeToSelector(arr = []) {
    let optionData = [];
    arr.forEach(item => {
        flatData(item.children, item.label, optionData);
    });
    return optionData;
}

function flatData(arr, label, newData) {
    arr &&
        arr.forEach(item => {
            let str = label ? label + ">" + item.label : item.label;
            newData.push({
                value: item.id,
                label: str
            });
            if (item.children && item.children.length != 0) {
                flatData(item.children, str, newData);
            }
        });
    return newData;
}
</script>

<style lang="less" scoped>
.entity-managemnet-wrap {
    display: flex;
    height: 100%;
    overflow: hidden;
    .table-panel {
        flex: 1;
        background: #fff;
        // padding: 0 24px 0 24px;
        border-radius: 4px;
        overflow-x: hidden;
        overflow-y: auto;

        .sp-describe {
            font-weight: normal;
            margin-left: 24px;
            font-size: 14px;
            span {
                color: #26d485;
            }
        }
        .top-operate {
            margin-bottom: 5px;
        }
        .notice {
            color: #ff782b;
            margin-bottom: 15px;
        }
        .top-right {
            display: flex;
        }
        .search-input {
            width: 380px;
        }
        .search-select {
            width: 130px;
            /deep/.el-input {
                border: 1px solid transparent;
            }
            /deep/.is-focus {
                border-color: #2088f3;
                transition: none;
                box-sizing: border-box;
                border-radius: 4px;
            }
            /deep/.el-input__inner {
                color: #606266;
                border: none;
                height: 30px;
                line-height: 30px;
            }
        }
        .bottom-panel {
            .el-checkbox {
                margin-right: 15px;
            }
        }
        .edit-link {
            font-size: 12px;
        }
        /deep/.el-icon-circle-close:before {
            color: #cbcfd5;
        }
        .import-btn {
            min-width: 60px;
            margin-left: 20px;
            border-radius: 20px 0 0 20px;
        }
        .exprot-btn {
            min-width: 60px;
            margin-left: -1px;
            border-radius: 0 20px 20px 0;
        }
        .span-border {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            vertical-align: bottom;
            width: 30px;
            height: 30px;
            border: 1px solid #d8e4f0;
            border-radius: 15px;
            margin-left: 20px;
            .info-icon {
                display: inline-block;
                width: 20px;
                height: 20px;
                cursor: pointer;
                background: url(//ossweb-img.qq.com/images/xiaoyue/images/manager/website/class-spr2.png) -101px -142px no-repeat;
                &:hover {
                    background-position: -127px -142px;
                }
            }
        }
    }
    .page-top-tips {
        max-width: max-content;
        border: 1px solid #2ec2ff;
        border-radius: 3px;
        padding: 6px 8px;
        margin: 10px 0 12px 16px;
        background-color: rgba(46, 194, 255, 0.06);
    }
}
</style>
